export default "__VITE_ASSET__CwOUOFYc__"